import { render, staticRenderFns } from "./OutgoingInvoiceCard.vue?vue&type=template&id=4f2af68a&scoped=true&"
import script from "./OutgoingInvoiceCard.vue?vue&type=script&lang=js&"
export * from "./OutgoingInvoiceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2af68a",
  null
  
)

export default component.exports